import React from 'react';
import { Inbox } from 'lucide-react';

const EmptyState = ({
  icon: Icon = Inbox,
  title,
  message,
  action,
  className = '',
  compact = false,
}) => (
  <div className={`text-center ${compact ? 'py-8' : 'py-12'} px-4 ${className}`}>
    <div
      className={`${compact ? 'w-12 h-12' : 'w-14 h-14'} mx-auto bg-neutral-100 rounded-full flex items-center justify-center mb-3`}
    >
      <Icon size={compact ? 22 : 28} className="text-neutral-400" />
    </div>
    {title && (
      <h3 className="text-base font-semibold text-neutral-800">{title}</h3>
    )}
    {message && (
      <p className="mt-1 text-sm text-neutral-500 max-w-sm mx-auto">{message}</p>
    )}
    {action && <div className="mt-4 inline-block">{action}</div>}
  </div>
);

export default EmptyState;
